import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClipboard: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="clipboard, copy, list"><path fillRule="evenodd" clipRule="evenodd" d="M15.5675 4H16.25C18.3211 4 20 5.67893 20 7.75V18.25C20 20.3211 18.3211 22 16.25 22H7.75C5.67893 22 4 20.3211 4 18.25V7.75C4 5.67893 5.67893 4 7.75 4H8.43252C9.06127 2.81055 10.311 2 11.75 2H12.25C13.689 2 14.9387 2.81055 15.5675 4ZM14.5 5.75C14.5 4.50736 13.4926 3.5 12.25 3.5H11.75C10.5074 3.5 9.5 4.50736 9.5 5.75V6.25C9.5 6.38807 9.61193 6.5 9.75 6.5H14.25C14.3881 6.5 14.5 6.38807 14.5 6.25V5.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconClipboard;
